import { StudyFormValues } from '../types/study-edit.interface';

export const DEFAULT_FORM_VALUES: Partial<StudyFormValues> = {
  subscriptionValidityDayInterval: 30,
  allowParticipantsToViewPreviousResponses: true,
  category: null,
  initialQuestionnaire: undefined,
  emaQuestionnaires: [],
};
